import { render, staticRenderFns } from "./MediaUploadGuidelines.vue?vue&type=template&id=af5f27cc&scoped=true"
import script from "./MediaUploadGuidelines.vue?vue&type=script&lang=ts"
export * from "./MediaUploadGuidelines.vue?vue&type=script&lang=ts"
import style0 from "./MediaUploadGuidelines.vue?vue&type=style&index=0&id=af5f27cc&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af5f27cc",
  null
  
)

export default component.exports